import { SERVER_URL } from "../../constants";

const BASE_URL = `${SERVER_URL}/api`;

export default BASE_URL;

